import UnsubscribeConfirmation from './UnsubscribeConfirmation';
export default UnsubscribeConfirmation;
